import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import UserFeeds from "./UserFeeds";
import UserFriends from "./UserFriends";
import UserGoldenSpace from "./UserGoldenSpace";
import UserGallery from "./UserGallery";
import UserAbout from "./UserAbout";
import ReactImageVideoLightbox from 'react-image-video-lightbox';
import { getlanguagelist } from "../../../helpers/changelanguage";
import { confirmAlert } from 'react-confirm-alert';
import $$  from "jquery";


import "./TabPanel.css";

function TabPanel(props) {
  $$('.react-swipeable-view-container').children('div').removeClass('remove_scroll');
  $$('.react-swipeable-view-container').find( `[aria-hidden="false"]` ).addClass('remove_scroll');
  const { children, value, index} = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
    >
    {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    flexGrow: 1,
  },
}));
export default function UserTabs(props) {
  let lightBoxData = [];
  let dedicatelist =  props.galleryDetails.dedicateList | [];
 /* dedicatelist.map((tile,index) => { 
    let newArr = {
      url    : tile.media_link,
      type   : tile.media_type == 'IMAGE' ? 'photo' : 'video',
      altTag : 'Image'
    } ;
    lightBoxData.push(newArr);
  })*/ 

  //props.setCurrentUserTab(props.activeTab);
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(props.activeTab);
  //console.log(value,props.activeTab);

  if((value != props.activeTab)  && (window.location.href.split('/')[5] != undefined)){
    setValue(props.activeTab);
  } 
  const handleChange = (event, newValue) => {

    if((props.private_profile == 'OFF') && (newValue == 3)){
      //alert('OFF');

      confirmAlert({
        title: languagelist.cofirm,
        message: languagelist.privateprofilealert,
        buttons: [
          {
            label: languagelist.dialogbuttonok,
            onClick: () => {
              //props.setCurrentUserTab(newValue);
              //setValue(newValue);
            }
          }
        ]
      });
    }else{
      props.setCurrentUserTab(newValue);
      setValue(newValue);
    }
    
  };
 

  const openDedicateLightBox = (index) => {
    props.openDedicateLightBox('',index);
  }
  let  languagelist = getlanguagelist();
  let selector = parseInt(value + 1);

  //$$('.react-swipeable-view-container').find( `[aria-hidden="false"]` ).addClass('remove_scroll');
  return (
    <div className="container">
    <div className={`tab_class ${classes.root} col-xs-12`}>
      
                <AppBar position="static" color="default">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                    >
                    <Tab label={languagelist.timeline}/>
                    <Tab label={languagelist.friends}/>
                    {/* <Tab label={languagelist.goldenspace}/> */}
                    <Tab label={languagelist.menu_gallery}/>
                    <Tab label={languagelist.about}/>
                    </Tabs>
                </AppBar>
      
     
      <div className="clr20"></div>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value} 
       
       >
        <TabPanel value={value} index={0} dir={theme.direction} >
            <UserFeeds urlId={props.urlId}/> 
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction} id="friend" style={{height : '10px'}}>
           <UserFriends urlId={props.urlId} />
        </TabPanel>
       {/*  <TabPanel value={value} index={2} dir={theme.direction}>
            Golden Space
        </TabPanel> */}
        <TabPanel value={value} index={2} dir={theme.direction} >
            <div className="gallery_area">
            <UserGallery 
              galleryDetails      = {props.galleryDetails} 
              changeCarousal      = {props.changeCarousal} 
              openDedicateLightBox= {props.openDedicateLightBox} 
              deleteUserFeed      = {props.deleteUserFeed} 
              ownProfile          = {props.ownProfile}
              uploadCarousal      = {props.uploadCarousal}
              />
            </div>
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction} >
           <UserAbout 
              urlId={props.urlId} 
              is_edit={props.galleryDetails.is_edit} 
           />
           
         {/*  {(props.galleryDetails.is_edit == 'true')
          ? <UserAboutEdit urlId={props.urlId}/>
          : <UserAbout urlId={props.urlId}/>
          } */}
        </TabPanel>
      </SwipeableViews>
      </div>
      {
       props.galleryDetails.lightboxOpen &&
       <div className="dedicate-light-box">
        <ReactImageVideoLightbox 
                  data={lightBoxData}
                  startIndex={ props.galleryDetails.lightBoxIndex}
                  showResourceCount={true}
                  onCloseCallback={() => openDedicateLightBox(0)} />
        </div>
      }
    </div>
    
  );
}
